import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { IncludedInModule } from '@portal-core/general/pipes/included-in/included-in.module';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { LicenseUserForLicenseAsyncModule } from '@portal-core/license-users/pipes/license-user-for-license-async/license-user-for-license-async.module';
import { WorkspaceFileUserStatusAvatarIndicatorModule } from '@portal-core/project-files/workspace/components/workspace-files-user-status-avatar-indicator/workspace-file-user-status-avatar-indicator.module';
import { WorkspaceFilesUserStatusListCurrentUserWarningModule } from '@portal-core/project-files/workspace/directives/workspace-files-user-status-list-current-user-warning/workspace-files-user-status-list-current-user-warning.module';
import { WorkspaceFilesUserStatusListWarningModule } from '@portal-core/project-files/workspace/directives/workspace-files-user-status-list-warning/workspace-files-user-status-list-warning.module';
import { SnackBarErrorModule } from '@portal-core/ui/snack-bar/components/snack-bar-error/snack-bar-error.module';
import { WorkspaceFilesUserStatusListComponent } from './workspace-files-user-status-list.component';

@NgModule({
  declarations: [WorkspaceFilesUserStatusListComponent],
  imports: [
    CommonModule,
    IncludedInModule,
    LicenseUserAvatarModule,
    LicenseUserForLicenseAsyncModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSnackBarModule,
    SnackBarErrorModule,
    WorkspaceFileUserStatusAvatarIndicatorModule,
    WorkspaceFilesUserStatusListCurrentUserWarningModule,
    WorkspaceFilesUserStatusListWarningModule
  ],
  exports: [
    WorkspaceFilesUserStatusListComponent,
    WorkspaceFilesUserStatusListCurrentUserWarningModule,
    WorkspaceFilesUserStatusListWarningModule
  ]
})
export class WorkspaceFilesUserStatusListModule { }
